import { differenceInDays, subDays } from 'date-fns'

/**
 * Returns the previous period date range of equal length, contiguous and
 * immediately before the given range (no overlap).
 *
 * Both start and end dates are treated as inclusive. For example, a 7-day
 * range Jan 1–7 produces a previous period of Dec 25–31.
 */
export function getPreviousPeriodDateRange(
  startDate: Date,
  endDate: Date,
): { previousStartDate: Date; previousEndDate: Date } {
  if (startDate > endDate) {
    throw new RangeError('startDate must be less than or equal to endDate')
  }
  const daysInRange = differenceInDays(endDate, startDate) + 1
  return {
    previousStartDate: subDays(startDate, daysInRange),
    previousEndDate: subDays(endDate, daysInRange),
  }
}
